module.exports = __webpack_public_path__ + "media/images/flags/1x1/cri-0098cf647c3c86576c41ac27615072a3.svg";